export default __webpack_public_path__ + "5ab0e6e990dcb984fa2291e45ae02b14.ttf";